import { History } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Button } from "@v2/components/ui/button";
import { formatSeasonDate, useSeason } from "../../lib/seasons";

/** Banner fisso quando si guarda una stagione chiusa. */
export function SeasonClosedBanner() {
  const { t } = useTranslation("seasons");
  const { isViewingClosed, selectedSeason, activeSeason, selectSeason } = useSeason();
  if (!isViewingClosed || !selectedSeason) return null;
  return (
    <div className="px-4 sm:px-6 pt-3 max-w-[1600px] w-full mx-auto">
      <div className="flex flex-wrap items-center gap-x-3 gap-y-2 rounded-lg border border-amber-200 bg-amber-50 text-amber-900 dark:border-amber-500/30 dark:bg-amber-500/10 dark:text-amber-100 px-3 py-2 text-sm">
        <History className="h-4 w-4 shrink-0" />
        <p className="flex-1 min-w-0 leading-snug">
          {t("banner.message", { name: selectedSeason.name, date: formatSeasonDate(selectedSeason.ends_on) })}
        </p>
        {activeSeason && (
          <Button
            size="sm"
            className="h-7 shrink-0 border-transparent bg-amber-600 text-white hover:bg-amber-700"
            onClick={() => selectSeason(activeSeason.id)}
          >
            {t("banner.back", { name: activeSeason.name })}
          </Button>
        )}
      </div>
    </div>
  );
}
